/* tslint:disable */
/* eslint-disable */
/**
 * Hire-help Tenant API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: contact@scalac.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Keys which mean the corresponding feature should be visible/enabled. Otherwise feature is disabled/hidden. unsafeUserSalary - get/set salary in finances, should be enabled on demo tenants only (not safe). frontendShowAllModules - show all in-progress views on FE side
 * @export
 * @enum {string}
 */

export const EnabledFeatures = {
    UnsafeUserSalary: 'unsafeUserSalary',
    FrontendShowAllModules: 'frontendShowAllModules',
    SendNewInvitationEmail: 'sendNewInvitationEmail'
} as const;

export type EnabledFeatures = typeof EnabledFeatures[keyof typeof EnabledFeatures];


/**
 * 
 * @export
 * @interface TenantMetadata
 */
export interface TenantMetadata {
    /**
     * 
     * @type {Array<EnabledFeatures>}
     * @memberof TenantMetadata
     */
    'enabledFeatures': Array<EnabledFeatures>;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get metadata of tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantMetadata: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Get metadata of tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantMetadata(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantMetadata(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DefaultApi.getTenantMetadata']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Get metadata of tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantMetadata(options?: any): AxiosPromise<TenantMetadata> {
            return localVarFp.getTenantMetadata(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Get metadata of tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTenantMetadata(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTenantMetadata(options).then((request) => request(this.axios, this.basePath));
    }
}



